import {useSessionStore} from "../store";
import {useEffect} from "react";

export const useSessionTimer = () => {
  const {sessionRemainingSeconds, decrementSessionRemainingSeconds} =
    useSessionStore();

  const shouldRunTimer =
    sessionRemainingSeconds !== null && sessionRemainingSeconds > 0;

  useEffect(() => {
    if (!shouldRunTimer) {
      return;
    }
    const timer = setInterval(() => {
      decrementSessionRemainingSeconds();
    }, 1000);
    return () => clearInterval(timer);
  }, [shouldRunTimer]);

  return {
    sessionRemainingSeconds,
  };
};
